import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      style: {"width":"100%","margin-bottom":"20px"},
      "row-key": "id",
      border: "",
      "default-expand-all": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "date",
          label: "ID",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "address",
          label: "",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "address2",
          label: "",
          sortable: ""
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}